var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "field has-addons",
      class: { "only-two": _vm.options.length <= 2 },
    },
    _vm._l(_vm.options, function (ref) {
      var value = ref.value
      var label = ref.label
      return _c(
        "b-radio-button",
        {
          key: value,
          class: "gtm-option" + (_vm.name ? "-" + _vm.name : "") + "-" + value,
          attrs: {
            "native-value": value,
            expanded: "",
            "data-test":
              "button__" + (_vm.name ? "" + _vm.name : "") + "-" + value,
          },
          model: {
            value: _vm.selected,
            callback: function ($$v) {
              _vm.selected = $$v
            },
            expression: "selected",
          },
        },
        [_c("span", [_vm._v(_vm._s(label))])]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }